"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var index_vue_1 = require("./index.vue");
var store_js_1 = require("../../../Controllers/Order/Main/src/store.js");
var appElement = document.querySelector('#v-cart-observer');
vue_1.createApp(index_vue_1.default)
    .use(store_js_1.default)
    .mount(appElement);
